import type { PartialOrganisationUserWithPartialUser } from 'services/assist-api/entities/customer-user/types';

export function friendlyMarkerName(
  organisationUser: PartialOrganisationUserWithPartialUser | undefined
): string {
  if (
    !organisationUser?.user.firstname ||
    !organisationUser?.user.lastname ||
    !organisationUser?.user.username
  )
    return 'Error: Marker details not found.';
  return `${organisationUser?.user.firstname} ${organisationUser?.user.lastname}`;
}
